module.exports = __webpack_public_path__ + "static/aopsafaribath1-43d821ea371425ff2f7b1bac1385bc5a.jpeg";